import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from 'src/app/shared.service';

@Component({
  selector: 'app-encash',
  templateUrl: './encash.component.html',
  styleUrls: ['./encash.component.scss']
})
export class EncashComponent implements OnInit 
{

  @Input() summary: any;

  noOfCashLeaves!: number;
  originalCasualBalance!: number;

  constructor(private service: SharedService) { }

  ngOnInit(): void 
  {
    this.noOfCashLeaves = this.summary.LeavesCashed;
    this.originalCasualBalance = this.summary.NewCasualBalance;
  }


  Test()
  {
    console.log(this.summary);
  }


  CashLeaves()
  {
    if(confirm("are you sure?"))
    {
      this.summary.LeavesCashed = this.noOfCashLeaves;
      this.summary.NewCasualBalance = this.originalCasualBalance - this.noOfCashLeaves;
      this.service.AddSummary(this.summary).subscribe(data =>
        {
          console.log(data)
        })
    }
  }
}
